import { Typography } from "@mui/material";
import facultyachievements from "../../utils/facultyAchievements.json";
import Tables from "../../components/Tables";
import ContentLayout from "../../components/ContentLayout";

type Props = {
  recipient: string;
  designation: string;
  description: string;
};

const FacultyAchievement = () => {
  const fa: Array<Props> = facultyachievements;
  const titles = [
    "Sr.No.",
    "Name Of The Recipient",
    "Designation",
    "Year",
    "Description",
  ];
  return (
    <ContentLayout
      children={
        <>
          <Typography variant="h5" fontWeight={600} pb={2}>
            Faculty Achievements
          </Typography>
          <Tables titles={titles} data={fa} />
        </>
      }
    />
  );
};

export default FacultyAchievement;
